import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { SearchGroupsByFilterPayload } from "../../payload/SearchGroupsByFilter/SearchGroupsByFilterPayload";

const searchGroupsByFilterFetch = (state: GroupsState, actions: PayloadAction<SearchGroupsByFilterPayload>) => {
    state.isLoading = true;
}

export default searchGroupsByFilterFetch;